import React from 'react';

const OrderContext = React.createContext({
  items: [],
  addItem: (item) => {},
  removeItem:(id)=>{}
});

export default OrderContext;
